import { gql } from "@apollo/client";

export const GET_SERVICE_TEMPLATES_BY_SERVICE_CATEGORY = gql`
  query serviceTemplatesByServiceCategory($serviceType: String!, $serviceCategory: String!, $branchId: String!) {
    serviceTemplatesByServiceCategory(serviceType: $serviceType, serviceCategory: $serviceCategory, branchId: $branchId) {
      id
      serviceCategory
      tasks {
        name
        description
        cost
      }
      status
    }
  }
`;

